import script from "./DashboardAdBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardAdBanner.vue?vue&type=script&setup=true&lang=js"

import "./DashboardAdBanner.vue?vue&type=style&index=0&id=34239bec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34239bec"]])

export default __exports__